export const environment = {
    production: true,
    // api_base_url: 'http://localhost:8083',
    api_base_url: 'https://subclient-api.etrace-eagro.com',
    google_maps_api_key: 'AIzaSyCLV7ITl458emT4vZbjaShKvHuuj6yqjTs'
};
